<template>
  <div>
    <booking-info :booking-info="bookingInfoProp"></booking-info>
    <v-row class="mt-5">
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="6"
      >
        <v-btn
          class="w-100"
          color="primary"
          @click="handleDailyRecord"
        >
          View Daily Record
        </v-btn>
      </v-col>
      <!-- <v-col
        v-if="showCancelBtn"
        cols="12"
        sm="12"
        md="6"
        lg="6"
      >
        <v-btn
          class="w-100"
          dark
          @click="cancelConfirmDialog = true"
        >
          Cancel Booking
        </v-btn>
      </v-col> -->
    </v-row>
    <!-- <v-dialog
      v-model="cancelConfirmDialog"
      width="300px"
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title>Information</v-card-title>
        <div class="ml-5">
          Are you sure to cancel booking
        </div>
        <v-card-actions class="justify-center">
          <v-btn
            @click="cancelConfirmDialog = false"
          >
            Back
          </v-btn>
          <v-btn
            color="primary"
            @click="handleCancel"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </div>
</template>
<script setup>
import { ref, computed, toRefs, watch, onMounted } from 'vue'
import moment from '@/utils/moment'
import { formatDate, formatTime, hasRole } from '@/utils/helper'
import BookingInfo from './BookingInfo'
import { cancel, deleteItem } from '@/api/bookedCourse'

const cancelConfirmDialog = ref(false)

const props = defineProps({
  bookingInfoProp: {
    type: Object,
    default() {
      return {
        id: -1,
        bookingNo: 'BAM2200001',
        userRecord: {
          fullName: 'Paul Chan',
        },
        center: {
          description: 'Mong Kok',
        },
        courseDate: '2023-02-16',
        courseStartTime: '2023-02-16T01:00:00.000Z',
        courseEndTime: '2023-02-16T02:00:00.000Z',
      }
    },
  },
})

// const showCancelBtn = computed(() => (
//   moment(props.bookingInfoProp.courseStartTime).isSameOrAfter(moment(), 'day')
//     && props.bookingInfoProp.bookingStatusId === 1
// ))
const showCancelBtn = ref(false)
const { bookingInfoProp } = toRefs(props)

// watch(bookingInfoProp, (newVal, oldVal) => {
//   // console.log('watch booking', newVal, oldVal)
//   console.log('newVal.courseStartTime', newVal.courseStartTime)
//   console.log('moment(newVal.courseStartTime).unix()', moment(newVal.courseStartTime).unix())
//   console.log('moment().unix()', moment().unix())
//   console.log("moment(newVal.courseStartTime).isSameOrAfter(moment(), 'day')", moment(newVal.courseStartTime).isSameOrAfter(moment(), 'day'))

//   // console.log('newVal.bookingStatusId', newVal.bookingStatusId)
//   if (moment(bookingInfoProp.value.courseStartTime).unix() > moment().unix() && newVal.courseStatusID === 1) {
//     showCancelBtn.value = true
//   } else {
//     showCancelBtn.value = false
//   }
// })

const emit = defineEmits(['canceled'])
function handleDailyRecord() {
  console.log('handleDailyRecord bookingInfoProp', bookingInfoProp)
}

const isStudent = ref(false)

onMounted(() => {
  // console.log('moment().utc()', moment())
  // console.log('bookingInfoProp.value.courseStartTime', bookingInfoProp.value.courseStartTime)
  // console.log('moment(bookingInfoProp.value.courseStartTime).unix()', moment(bookingInfoProp.value.courseStartTime).unix())
  // console.log('moment().unix()', moment().unix())
  // console.log("moment(bookingInfoProp.value.courseStartTime).isSameOrAfter(moment(), 'day')", moment(bookingInfoProp.value.courseStartTime).isSameOrAfter(moment(), 'day'))

  // // console.log('newVal.bookingStatusId', newVal.bookingStatusId)
  // if (moment(bookingInfoProp.value.courseStartTime).unix() > moment().unix() && bookingInfoProp.value.courseStatusID === 1) {
  //   showCancelBtn.value = true
  // } else {
  //   showCancelBtn.value = false
  // }

  const roleArr = hasRole([1])
  if (roleArr.length > 0) {
    isStudent.value = true
  }
})

// Define the handleCancel function
// function handleCancel() {
//   // Log the bookingInfoProp object to the console
//   // console.log('handleCancel bookingInfoProp', bookingInfoProp)

//   // Check if the current time is early than 24 hours (86400 seconds) before the course start time
//   if (moment().unix() < moment(bookingInfoProp.value.courseStartTime).unix() - 86400) {
//     // If true, delete the booking item by calling the deleteItem function with the booking ID
//     deleteItem({
//       id: bookingInfoProp.value.id || -1,
//     }).then(response => {
//       // Log the response from the deleteItem function
//       console.log('handleCancel', response)

//       // If the response code is 20000, emit the 'canceled' event
//       if (response.code === 20000) {
//         emit('canceled')
//       }
//     })

//   // Check if the current time is within 24 hours before the course start time and the user is a student
//   } else {
//     // If true, display a confirmation message to the student
//     const result = confirm('Even you canceled booking, the course would still withdraw.')

//     // Log the result of the confirmation
//     console.log('confirm result', result)

//     // If the student confirms, call the cancel function with the booking ID
//     if (result) {
//       cancel({
//         id: bookingInfoProp.value.id || -1,
//       }).then(response => {
//         // Log the response from the cancel function
//         console.log('handleCancel', response)

//         // If the response code is 20000, emit the 'canceled' event
//         if (response.code === 20000) {
//           emit('canceled')
//         }
//       })
//     }
//   }
// }

</script>
<style>
  .w-100{
    width: 100%;
  }
</style>
